export const i18nStyleguideEn = {
  error_fallback: {
    error_msg: 'An error has occurred, please contact support if the problem persists.',
  },
};
